import { combineReducers } from "redux"
import Login from "./auth/login/reducer"
import Loader from "./loading/reducer"
import Seller from "./sellers/reducer"
import Category from "./categories/reducer"
import Department from "./departments/reducer"
import Product from "./products/reducer"
import Pagination from "./pagination/reducer"


const rootReducer = combineReducers({
  Login,
  Loader,
  Seller,
  Category,
  Department,
  Product,
  Pagination
})

export default rootReducer